import React from 'react';
import { Button, Icon, Input, useMediaQueryContext } from '@fourthwall/components';
import { FacebookIcon, TickIcon, TwitterIcon, LinkedInIcon } from '@fourthwall/icons';
import { useCopyToClipboard } from '@components/hooks/useCopyToClipboard';
import { useTagManager } from '@hooks';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import * as S from './CopyLinkInputWithSocialShares.styled';
const shareTitle = 'Want to make your own custom shop?';
const shareText = 'Use my link below to get free store credit and build your own custom storefront on Fourthwall.';
export const CopyLinkInputWithSocialShares = ({ analytics, href }) => {
    const { tablet } = useMediaQueryContext();
    const { currentShop } = useCurrentShop();
    const tagManager = useTagManager();
    const { isCopied, copyToClipboard } = useCopyToClipboard();
    const label = tablet ? 'Copy link' : 'Copy';
    const onFacebookClick = () => {
        const facebookShareUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(href)}`;
        tagManager.trigger('shareReferralOnSocialMedia', {
            shop_id: currentShop?.id || '',
            social_media: 'facebook',
        });
        window.open(facebookShareUrl, '_blank', 'width=600,height=400');
    };
    const onTwitterClick = () => {
        const combinedText = `${shareTitle}\n\n${shareText}\n\n${href}`;
        const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(combinedText)}`;
        tagManager.trigger('shareReferralOnSocialMedia', {
            shop_id: currentShop?.id || '',
            social_media: 'twitter',
        });
        window.open(twitterShareUrl, '_blank', 'width=600,height=400');
    };
    const onLinkedInClick = () => {
        const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(href)}`;
        tagManager.trigger('shareReferralOnSocialMedia', {
            shop_id: currentShop?.id || '',
            social_media: 'linkedin',
        });
        window.open(linkedInShareUrl, '_blank', 'width=600,height=400');
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.InputWrapper, null,
            React.createElement(Input, { readOnly: true, size: "medium", value: href, fullWidth: true })),
        React.createElement(S.ButtonWrapper, null,
            React.createElement(Button, { fullWidth: true, appearance: "primary", label: isCopied ? 'Copied' : label, leftIcon: isCopied ? React.createElement(Icon, { component: TickIcon, height: 16 }) : undefined, size: "medium", analytics: analytics, disabled: isCopied, onClick: () => {
                    copyToClipboard(href);
                } }),
            React.createElement(S.SocialButtonsWrapper, null,
                React.createElement(Button, { appearance: "secondary", leftIcon: React.createElement(Icon, { component: FacebookIcon, height: 16 }), onClick: onFacebookClick, analytics: analytics }),
                React.createElement(Button, { appearance: "secondary", leftIcon: React.createElement(Icon, { component: TwitterIcon, height: 16 }), onClick: onTwitterClick, analytics: analytics }),
                React.createElement(Button, { appearance: "secondary", leftIcon: React.createElement(Icon, { component: LinkedInIcon, height: 16 }), onClick: onLinkedInClick, analytics: analytics })))));
};
